import { computed } from 'mobx';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class MarketListDataService extends DataService<typeof Model.General.Logic.ViewModels.MarketSummary, Model.General.Logic.ViewModels.MarketSummary, MarketSummary> {
    protected map(entity: Model.General.Logic.ViewModels.MarketSummary): MarketSummary {
        return new MarketSummaryModel(entity);
    }

    public static make(context?: any): MarketListDataService {
        return new MarketListDataService(context, ctx => ctx.MarketSummaries);
    }
}

export class MarketSummaryModel extends EntityModel<Model.General.Logic.ViewModels.MarketSummary, MarketSummary> implements MarketSummary {

    @property<MarketSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<MarketSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;

    @property<MarketSummaryModel>(o => o.entity.name, (o, value) => o.entity.name = value)
    public name: string;

    @property<MarketSummaryModel>(o => o.entity.currencyId, (o, value) => o.entity.currencyId = value)
    public currencyId: number;

    @property<MarketSummaryModel>(o => o.entity.currencyDisplayName, (o, value) => o.entity.currencyDisplayName = value)
	public currencyDisplayName: string;

	@property<MarketSummaryModel>(o => o.entity.currencySymbol, (o, value) => o.entity.currencySymbol = value)
	public currencySymbol: string;

    @property<MarketSummaryModel>(o => o.entity.defaultMargin, (o, value) => o.entity.defaultMargin = value)
	public defaultMargin: number;

	@property<MarketSummaryModel>(o => o.entity.requiresPayment, (o, value) => o.entity.requiresPayment = value)
	public requiresPayment: boolean;

	@property<MarketSummaryModel>(o => o.entity.depositPercent, (o, value) => o.entity.depositPercent = value)
	public depositPercent: number;

	@property<MarketSummaryModel>(o => o.entity.invoiceDueDateInDays, (o, value) => o.entity.invoiceDueDateInDays = value)
	public invoiceDueDateInDays: number;

    @property<MarketSummaryModel>(o => o.entity.marginPolicy, (o, value) => o.entity.marginPolicy = value)
    public marginPolicy: number;

	@property<MarketSummaryModel>(o => o.entity.defaultTaxId, (o, value) => o.entity.defaultTaxId = value)
	public defaultTaxId: number;

    @computed
    public get marginPolicyText(): string {
        switch (this.marginPolicy) {
            case 0:
                return 'Margin only from Market';
            case 1:
                return 'Margin only from Supplier';
            case 2:
                return 'Margin from Market + Supplier';
        }
        return null;
    }

    @property<MarketSummaryModel>(o => o.entity.marketPriceType, (o, value) => o.entity.marketPriceType = value)
    public marketPriceType: number;

    @computed
    public get marketPriceTypeText(): string {
        switch (this.marketPriceType) {
            case 0:
                return 'Round Up';
            case 1:
                return 'Round Down';
            case 2:
                return 'Exact value';
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/general/market/list/market-list.data.ts